<app-chat
  *ngIf="(preferences.settings$ | async)?.publicChatId as publicChatId; else noDataTmp"
  [chatId]="publicChatId"
></app-chat>

<ng-template #noDataTmp>
  <div class="no-data">
    {{ 'components.chatPublicPage.labels.nodata' | translate }}
  </div>
</ng-template>
